@defer {
	<div class="flex flex-col gap-10 pt-28">
		<div class="flex flex-col md:flex-row justify-around items-center gap-4">
			<div class="flex justify-center md:justify-start">
				<div class="bg-[url(/assets/images/cross.avif)] bg-no-repeat w-32 h-36 flex flex-col items-center justify-center md:items-start text-peps-dark-200">
					<h2 class="text-5xl sm:text-5xl z-30 text-left text-nowrap md:translate-x-8 uppercase">{{ gallery!.translations[translateDynamicService.getLang()].eventName }}</h2>
					<h1 class="text-3xl sm:text-4xl z-30 text-left text-nowrap md:translate-x-8 uppercase">{{ gallery!.date | localizedDate:'dd/MM/yyyy' }} - {{ gallery!.authors.join(', ') }}</h1>
				</div>
			</div>
			<span class="invisible sm:visible"></span>
		</div>
		<div>
			<div class="w-6/12 mx-auto font-notosans text-justify z-[10]">
				{{ gallery!.translations[translateDynamicService.getLang()].description }}
			</div>
		</div>
		<div class="columns-1 sm:columns-2 md:columns-3 gap-2 p-4 mx-auto w-full sm:w-10/12">
			@for (photo of displayedPhotos; track photo.id) {
				<div class="mb-2 break-inside-avoid" (click)="openPhoto(photo)" (keydown.enter)="openPhoto(photo)">
					<div class="overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-300">
						<img
							[src]="minioBaseUrl + photo.imageKey"
							class="w-full object-cover transition-opacity duration-500 ease-in-out opacity-0 cursor-pointer"
							(load)="onImageLoad($event)"
							[alt]="photo.author"
						/>
					</div>
				</div>
			}
		</div>

		@if(totalPages > 1) {
			<peps-page-selector
				[page]="page"
				[totalPages]="totalPages"
				(pageChange)="onPageChange($event)"
			></peps-page-selector>
		}
	</div>
}

@if(isShowingModal && currentPhoto) {
	<div class="relative z-50" aria-labelledby="modal-title" role="dialog" aria-modal="true">
		<div class="fixed inset-0 bg-peps-dark-700/75 transition-opacity" aria-hidden="true" (click)="closeModal()"></div>

		<div class="fixed inset-0 z-50 w-screen pointer-events-none">
			<div class="flex min-h-full justify-center p-4 text-center items-center sm:p-0">
				<div class="relative w-full sm:w-10/12 md:w-8/12 py-4 max-h-screen items-center flex flex-col justify-center  pointer-events-auto">
					<img
						[src]="minioBaseUrl + currentPhoto!.imageKey"
						[alt]="currentPhoto!.author"
						class="max-w-full object-contain max-h-[80vh]"
					/>
					<div class="bottom-8 absolute w-full flex flex-col gap-8">
						<div class="flex flex-row justify-around">
							<button
								class="z-10 bg-peps-gold hover:bg-peps-yellow cursor-pointer p-1.5 lg:p-2.5 text-peps-dark-700"
								(click)="prevPhoto()"
							>
								<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4 lg:size-6 3xl:size-9">
									<path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
								</svg>
							</button>

							<button
								class="z-10 bg-peps-gold hover:bg-peps-yellow cursor-pointer p-1.5 lg:p-2.5 text-peps-dark-700"
								(click)="closeModal()"
							>
								<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4 lg:size-6 3xl:size-9">
									<path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
								</svg>

							</button>

							<button
								class="z-10 bg-peps-gold hover:bg-peps-yellow cursor-pointer p-1.5 lg:p-2.5 text-peps-dark-700"
								(click)="nextPhoto()"
							>
								<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4 lg:size-6 3xl:size-9">
									<path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
								</svg>
							</button>
						</div>
						<div class="w-full flex flex-row justify-center">
							<span class="w-fit p-2 bg-peps-dark-700 uppercase text-peps-dark-200 font-dinpro-medium text-base">{{ gallery!.translations[translateDynamicService.getLang()].eventName }} - {{ gallery!.date | localizedDate:'dd/MM/yyyy' }} - {{ currentPhoto.author.name }}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

}
